export interface FlasherConfig {
  productName: string;
  firmwareUrl: string;
  bootloaderUsbFilter: { usbVendorId: number; usbProductId: number };
  firmwareLabel: string;
}

export const config: FlasherConfig = {
  productName: "Update Your CNCjogger Stick",
  // Cache-bust query MUST be bumped on every firmware update — public/ assets
  // aren't fingerprinted by Vite, so the bare path gets pinned in Cloudflare's
  // edge cache and customers would download the previous firmware. Bump to match
  // firmwareLabel on each release (e.g. ?v=fw-f -> ?v=fw-g).
  firmwareUrl: "/firmware/firmware.zip?v=fw-f",
  bootloaderUsbFilter: { usbVendorId: 0x1915, usbProductId: 0x521f },
  firmwareLabel: "FW-F",
};
